import React, { useContext, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { Formik, Form, ErrorMessage } from "formik";
import Cookies from "js-cookie";
import * as Yup from "yup";
import { ProfileSection } from "../context/ProfileContext";
import { setNewSupport } from "../api";
import { Alert } from "./";
import { withRouter } from "react-router-dom";
import { useTranslation } from "react-i18next";

const ContactUsComp = (props) => {
  const { t } = useTranslation();
  const { ProfileShowHideFunc } = useContext(ProfileSection);
  const supportTypeList = useSelector((state) => state.supportTypeList);
  const supportMine = useSelector((state) => state.supportMine);
  const token = Cookies.get("token");
  const form = useRef();
  const initialContactUsValues = {
    type: "",
    body: "",
  };
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: "",
    type: "",
  });

  const submitContactUsForm = () => {
    const data = new FormData(form.current);
    setNewSupport(data, token)
      .then(() => {
        form.current.reset();
        setShowAlert((prevState) => ({
          ...prevState,
          show: true,
          message: t("درخواست شما با موفقیت ارسال شد."),
          type: "Success",
        }));
        setTimeout(() => {
          setShowAlert((prevState) => ({
            ...prevState,
            show: false,
          }));
        }, 3000);
      })
      .catch((err) => {
        if (err.response.status === 403) {
          Cookies.remove("token");
          props.history.push("/login");
        }
      });
  };

  const validationSchemaContactUs = Yup.object({
    type: Yup.string().required(t("یک گزینه را انتخاب کنید")),
    body: Yup.string().required(t("توضیحات را وارد کنید.")),
  });

  return (
    <div>
      <p className="text-right mb-4">{t("پشتیبانی")}</p>
      <div style={{ height: "44vh" }}>
        <Formik
          initialValues={initialContactUsValues}
          onSubmit={submitContactUsForm}
          validationSchema={validationSchemaContactUs}
        >
          {(props) => (
            <Form ref={form}>
              <div className="mb-3">
                <div className="inputs d-flex flex-column justify-content-center w-100 p-1">
                  {props.values.body && (
                    <p className="fn12 m-0 text-right">{t("توضیحات")}</p>
                  )}
                  <textarea
                    rows="5"
                    value={props.values.body}
                    placeholder={t("توضیحات")}
                    name="body"
                    className="w-100 fn12"
                    onChange={props.handleChange}
                    onBlur={props.handleBlur}
                  />
                </div>
                <ErrorMessage name="body">
                  {(errMsg) => (
                    <div className="text-danger fn10 mt-1">{errMsg}</div>
                  )}
                </ErrorMessage>
              </div>
              <div className="mb-3">
                <p className="fn12 mb-1 text-right">{t("نوع")}</p>
                <select
                  className="inputs w-100 fn12"
                  name="type"
                  value={props.values.type}
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                >
                  <option value="" label={t("یک گزینه را انتخاب کنید")} />
                  {supportTypeList?.map((type, index) => (
                    <option value={type.id} label={type.caption} key={index} />
                  ))}
                </select>
                <ErrorMessage name="type">
                  {(errMsg) => (
                    <div className="text-danger fn10 mt-1">{errMsg}</div>
                  )}
                </ErrorMessage>
              </div>
              <div className="mr-auto">
                <button
                  type="submit"
                  className="btn btn-primary px-4 py-1 text-white"
                >
                  {t("ثبت")}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </div>
      <div style={{ height: "25vh", overflow: "auto" }}>
        {supportMine?.map((ticket, index) => (
          <div
            className="textCard text-justify p-3 m-3 position-relative"
            key={index}
          >
            <p className="m-0 fn12">{ticket.body}</p>
            <small
              className="bg-white fn10 px-2 shadow position-absolute"
              style={{ bottom: "-6px", left: "9px" }}
            >
              {ticket.status}
            </small>
          </div>
        ))}
      </div>
      <div className="d-flex flex-wrap justify-content-around mt-3">
        <div
          onClick={() => ProfileShowHideFunc("setting")}
          className="mx-3 d-flex justify-content-center align-items-center flex-column text-center"
        >
          <span className="profileAddUser bg-white d-block icon-left-1 cursor"></span>
          <small className="fn10 mt-1">{t("بازگشت")}</small>
        </div>
      </div>
      {showAlert.show && (
        <Alert message={showAlert.message} type={showAlert.type} />
      )}
    </div>
  );
};

const ContactUs = withRouter(ContactUsComp);

export { ContactUs };
